module.exports = __webpack_public_path__ + "assets/img/vPublished.479eec95.svg";